/* Arch Addicts accessibility toolbar.
   Settings live in the visitor's own browser. Nothing is sent anywhere. */
(function () {
  'use strict';

  var KEY = 'aa-access-v1';
  var SCALES = [1, 1.15, 1.3, 1.5];
  var CONTRASTS = ['off', 'high', 'invert', 'gray'];
  var CONTRAST_LABEL = { off: 'Off', high: 'High contrast', invert: 'Inverted', gray: 'Greyscale' };

  var state = {
    textStep: 0,
    contrast: 'off',
    links: false,
    font: false,
    spacing: false,
    motion: false,
    cursor: false,
    guide: false,
    speak: false
  };

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) Object.assign(state, JSON.parse(raw));
    } catch (e) {}
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  /* ---------- text scaling ----------
     Record each element's own font size once, then scale from that original
     so repeated changes never compound. */
  var originals = null;
  function collectOriginals() {
    originals = [];
    var all = document.body.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.closest('.aa-access-panel, .aa-access-btn')) continue;
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'SVG' || tag === 'PATH') continue;
      var px = parseFloat(getComputedStyle(el).fontSize);
      if (px) originals.push([el, px]);
    }
  }
  function applyText() {
    var f = SCALES[state.textStep] || 1;
    if (f === 1) {
      if (originals) originals.forEach(function (p) { p[0].style.fontSize = ''; });
      return;
    }
    if (!originals) collectOriginals();
    originals.forEach(function (p) { p[0].style.fontSize = (p[1] * f).toFixed(2) + 'px'; });
  }

  /* ---------- reading guide ---------- */
  var guideEl = null;
  function onMove(e) { if (guideEl) guideEl.style.top = (e.clientY - 1) + 'px'; }
  function applyGuide() {
    if (state.guide && !guideEl) {
      guideEl = document.createElement('div');
      guideEl.className = 'aa-guide';
      guideEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(guideEl);
      document.addEventListener('mousemove', onMove);
    } else if (!state.guide && guideEl) {
      document.removeEventListener('mousemove', onMove);
      guideEl.remove();
      guideEl = null;
    }
  }

  /* ---------- read aloud ---------- */
  var speakable = 'p, h1, h2, h3, h4, li, blockquote, figcaption';
  var lastSpoken = null;
  function onSpeakClick(e) {
    if (!state.speak) return;
    if (e.target.closest('.aa-access-panel, .aa-access-btn')) return;
    var el = e.target.closest(speakable);
    if (!el) return;
    var text = (el.innerText || '').trim();
    if (!text) return;
    e.preventDefault();
    try {
      window.speechSynthesis.cancel();
      if (lastSpoken) lastSpoken.classList.remove('aa-speaking');
      var u = new SpeechSynthesisUtterance(text);
      u.lang = document.documentElement.lang || 'en';
      u.onend = function () { el.classList.remove('aa-speaking'); };
      el.classList.add('aa-speaking');
      lastSpoken = el;
      window.speechSynthesis.speak(u);
    } catch (err) {}
  }

  function applyAll() {
    var h = document.documentElement;
    h.classList.toggle('aa-links', state.links);
    h.classList.toggle('aa-readable-font', state.font);
    h.classList.toggle('aa-spacing', state.spacing);
    h.classList.toggle('aa-no-motion', state.motion);
    h.classList.toggle('aa-cursor', state.cursor);
    h.classList.toggle('aa-speak', state.speak);
    CONTRASTS.forEach(function (c) {
      h.classList.toggle('aa-contrast-' + c, c !== 'off' && state.contrast === c);
    });
    applyText();
    applyGuide();
    if (!state.speak) { try { window.speechSynthesis.cancel(); } catch (e) {} }
    save();
    sync();
  }

  /* ---------- panel ---------- */
  var btn, panel, scrim, lastFocus;

  function toggleRow(id, label) {
    return '<button type="button" class="aa-opt" data-toggle="' + id + '" aria-pressed="false">' +
           '<span>' + label + '</span><span class="aa-opt__state">Off</span></button>';
  }

  function build() {
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aa-access-btn';
    btn.setAttribute('aria-label', 'Accessibility options');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<circle cx="12" cy="3.8" r="2.1"/>' +
      '<path d="M20.4 7.1c-2.6.8-5.4 1.2-8.4 1.2s-5.8-.4-8.4-1.2a1.05 1.05 0 1 0-.6 2c1.9.6 3.9 1 6 1.2v2.3L6.4 20a1.05 1.05 0 0 0 1.9.9L12 14.4l3.7 6.5a1.05 1.05 0 0 0 1.9-.9l-2.6-7.4v-2.3c2.1-.2 4.1-.6 6-1.2a1.05 1.05 0 1 0-.6-2z"/>' +
      '</svg>';
    document.body.appendChild(btn);

    panel = document.createElement('div');
    panel.className = 'aa-access-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'aa-access-title');
    panel.innerHTML =
      '<div class="aa-access-panel__bar">' +
        '<h2 class="aa-access-panel__title" id="aa-access-title">Accessibility options</h2>' +
        '<button type="button" class="aa-access-panel__close" aria-label="Close accessibility options">&times;</button>' +
      '</div>' +
      '<div class="aa-access-panel__body">' +
        '<div class="aa-access-group"><h3>Text</h3>' +
          '<div class="aa-steps">' +
            '<button type="button" data-text="-" aria-label="Decrease text size">&minus;</button>' +
            '<output id="aa-text-out" aria-live="polite">100%</output>' +
            '<button type="button" data-text="+" aria-label="Increase text size">+</button>' +
          '</div>' +
          toggleRow('font', 'Readable font') +
          toggleRow('spacing', 'More spacing') +
        '</div>' +
        '<div class="aa-access-group"><h3>Colour</h3>' +
          '<button type="button" class="aa-opt" data-contrast aria-pressed="false">' +
            '<span>Contrast</span><span class="aa-opt__state" id="aa-contrast-out">Off</span></button>' +
          toggleRow('links', 'Underline links') +
        '</div>' +
        '<div class="aa-access-group"><h3>Navigation</h3>' +
          toggleRow('cursor', 'Large cursor') +
          toggleRow('guide', 'Reading guide') +
          toggleRow('motion', 'Stop animations') +
        '</div>' +
        '<div class="aa-access-group"><h3>Read aloud</h3>' +
          toggleRow('speak', 'Click text to hear it') +
        '</div>' +
        '<button type="button" class="aa-access-reset">Reset everything</button>' +
        '<p class="aa-access-note">Your choices are saved in this browser only. They change nothing for anyone else.</p>' +
      '</div>';
    document.body.appendChild(panel);
  }

  function sync() {
    if (!panel) return;
    panel.querySelectorAll('[data-toggle]').forEach(function (b) {
      var on = !!state[b.getAttribute('data-toggle')];
      b.setAttribute('aria-pressed', String(on));
      b.querySelector('.aa-opt__state').textContent = on ? 'On' : 'Off';
    });
    var out = panel.querySelector('#aa-text-out');
    if (out) out.textContent = Math.round((SCALES[state.textStep] || 1) * 100) + '%';
    var c = panel.querySelector('#aa-contrast-out');
    if (c) c.textContent = CONTRAST_LABEL[state.contrast];
    var cb = panel.querySelector('[data-contrast]');
    if (cb) cb.setAttribute('aria-pressed', String(state.contrast !== 'off'));
  }

  function open() {
    lastFocus = document.activeElement;
    scrim = document.createElement('div');
    scrim.className = 'aa-scrim';
    scrim.addEventListener('click', close);
    document.body.appendChild(scrim);
    panel.setAttribute('data-open', '');
    btn.setAttribute('aria-expanded', 'true');
    panel.querySelector('.aa-access-panel__close').focus();
  }
  function close() {
    panel.removeAttribute('data-open');
    btn.setAttribute('aria-expanded', 'false');
    if (scrim) { scrim.remove(); scrim = null; }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function isOpen() { return panel.hasAttribute('data-open'); }

  function wire() {
    btn.addEventListener('click', function () { isOpen() ? close() : open(); });
    panel.querySelector('.aa-access-panel__close').addEventListener('click', close);

    panel.addEventListener('click', function (e) {
      var t = e.target.closest('[data-toggle],[data-text],[data-contrast],.aa-access-reset');
      if (!t) return;
      if (t.hasAttribute('data-toggle')) {
        var k = t.getAttribute('data-toggle');
        state[k] = !state[k];
      } else if (t.hasAttribute('data-text')) {
        var d = t.getAttribute('data-text') === '+' ? 1 : -1;
        state.textStep = Math.min(SCALES.length - 1, Math.max(0, state.textStep + d));
      } else if (t.hasAttribute('data-contrast')) {
        state.contrast = CONTRASTS[(CONTRASTS.indexOf(state.contrast) + 1) % CONTRASTS.length];
      } else {
        Object.keys(state).forEach(function (k) {
          state[k] = (k === 'textStep') ? 0 : (k === 'contrast' ? 'off' : false);
        });
      }
      applyAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { close(); return; }
      if (e.key !== 'Tab' || !isOpen()) return;
      var f = panel.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('click', onSpeakClick, true);
  }

  function init() {
    if (document.querySelector('.aa-access-btn')) return;
    load();
    build();
    wire();
    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
